import { useState } from 'react';

export const useCollapsedGroups = (forceOpen: boolean) => {
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

  return (id: string) => ({
    collapsed: !forceOpen && Boolean(collapsed[id]),
    disabled: forceOpen,
    onToggle: () => setCollapsed((prev) => ({ ...prev, [id]: !prev[id] })),
  });
};

export type GroupFold = ReturnType<typeof useCollapsedGroups>;
